import React, { useEffect, useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import moment from "moment";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";

function DateRangeFilterV2({ dates, setDates }) {
  const [mode, setMode] = useState("all");
  const [showPicker, setShowPicker] = useState(false);
  const [selectedRange, setSelectedRange] = useState({
    start: dates.start || new Date(),
    end: dates.end || new Date(),
  });

  useEffect(() => {
    document.body.classList.toggle("filter-active", showPicker);
    return () => document.body.classList.remove("filter-active");
  }, [showPicker]);

  const handleAllButtonClick = () => {
    setMode("all");
    setDates({ start: null, end: null });
    setSelectedRange({ start: null, end: null });
    setShowPicker(false);
  };

  const handleApply = () => {
    setMode("custom");
    setDates(selectedRange);
    setShowPicker(false);
  };

  const handleRangeChange = (ranges) => {
    setSelectedRange({
      start: ranges.selection.startDate,
      end: moment(ranges.selection.endDate).endOf("day").toDate(),
    });
  };

  return (
    <div className="dashboard-v2__date-filter">
      <button type="button" className="dashboard-v2__date-btn" onClick={() => setShowPicker(true)}>
        <EventOutlinedIcon />
        {mode === "custom" && selectedRange.start && selectedRange.end
          ? `${moment(selectedRange.start).format("DD MMM, YY")} - ${moment(selectedRange.end).format("DD MMM, YY")}`
          : "Date"}
      </button>

      {showPicker && <div className="showoverlay" onClick={() => setShowPicker(false)} />}

      {showPicker && (
        <div className="daterangepickerf dashboard-v2__date-picker">
          <DateRangePicker
            ranges={[
              {
                startDate: selectedRange.start,
                endDate: selectedRange.end,
                key: "selection",
              },
            ]}
            onChange={handleRangeChange}
            moveRangeOnFirstSelection={false}
            editableDateInputs={true}
            onClose={() => setShowPicker(false)}
          />
          <div className="dashboard-v2__date-actions">
            <button type="button" className="dashboard-v2__date-apply" onClick={handleApply}>
              Apply
            </button>
            <button type="button" className="dashboard-v2__date-all" onClick={handleAllButtonClick}>
              All
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default DateRangeFilterV2;
